import { INavbarData } from './helper';

export const navbarData: INavbarData[] = [
  //   {
  //     routeLink: '/',
  //     icon: 'space_dashboard',
  //     label: 'Panel',
  //     iconColor: '#2E7D32',
  //     backgroundColor: '#E8F5E9'
  // },
  // {
  //     routeLink: '/cart',
  //     icon: 'shopping_cart',
  //     label: 'Sepetim',
  //     iconColor: '#1565C0',
  //     backgroundColor: '#E3F2FD',
  //     code: 'GET.Reading.MüşterialışverişsepetiListesiGetirir',
  //     code2: 'GET.Reading.MüşterialışverişsepetiListesiGetirir'
  // },
  // {
  //     routeLink: 'demand-management',
  //     icon: 'fact_check',
  //     label: 'Talep Yönetimi',
  //     iconColor: '#F57C00',
  //     backgroundColor: '#FFF3E0',
  //     code: 'GET.Reading.TalepYonetiminiGör(Aç/Kapat)',
  //     code2: 'GET.Reading.TalepYonetiminiGör(Aç/Kapat)'
  // },
  // {
  //     routeLink: 'approval-processes',
  //     icon: 'fact_check',
  //     label: 'Onay İşlemleri',
  //     iconColor: '#7B1FA2',
  //     backgroundColor: '#F3E5F5',
  //     code: 'GET.Reading.OnayIslemleriniGör(Aç/Kapat)',
  //     code2: 'GET.Reading.OnayIslemleriniGör(Aç/Kapat)'
  // },
  {
    routeLink: '/management',
    icon: 'admin_panel_settings',
    label: 'Yönetim',
    iconColor: '#37474F',
    backgroundColor: '#ECEFF1',
    code: 'GET.Reading.TanımlarSayfasıTanımlarıGetirme',
    code2: 'GET.Reading.TanımlarSayfasıTanımlarıGetirme',
  },
  // {
  //     routeLink: '/report-management',
  //     icon: 'assessment',
  //     label: 'Raporlar',
  //     iconColor: '#00838F',
  //     backgroundColor: '#E0F7FA',
  //     code: 'GET.Reading.RapolarSayfasiniGör(Aç/Kapat)',
  //     code2: 'GET.Reading.RapolarSayfasiniGör(Aç/Kapat)'
  // },
  {
    routeLink: '/settings',
    icon: 'tune',
    label: 'Tanımlar',
    iconColor: '#00838F',
    backgroundColor: '#E0F7FA',
    code: 'GET.Reading.TanımlarSayfasıTanımlarıGetirme',
    code2: 'GET.Reading.TanımlarSayfasıTanımlarıGetirme',
  },
];

// {
//   routeLink: '/',
//   icon: 'add_circle_outline',
//   label: 'TalepS',
//   class1:'menu',
// },
// {
//     routeLink: 'demandmanagement',
//     icon: 'add_circle_outline',
//     label: 'Talep Yönetimi'
// },
